import { ArrowUpRight, Play } from "@phosphor-icons/react";
import PressVideo from "@/components/site/PressVideo";

// "Featured on News 12" — the actual segment, playing on the page.
// Reads whichever press entry carries a video, so a future segment only
// needs an entry in /data/press.js.
export const PressVideoFeature = ({ item, compact = false }) => {
  if (!item?.video?.hls) return null;

  return (
    <div data-testid="press-video-feature" className="w-full">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-4">
        <span
          data-testid="press-video-outlet"
          className="inline-flex items-center gap-2 border border-white/25 bg-white/[0.04] px-3 py-1.5"
        >
          <span className="text-[10px] font-black uppercase tracking-[0.28em] text-white">
            {item.outlet}
          </span>
          <span className="text-[10px] uppercase tracking-[0.22em] text-white/45">
            {item.outletNote}
          </span>
        </span>
        <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] text-[#B32027] font-bold">
          <Play size={11} weight="fill" /> Video segment
        </span>
      </div>

      <div className="border border-white/10 bg-black">
        <PressVideo
          src={item.video.hls}
          poster={item.video.poster}
          title={item.headline}
          testId="news12-video"
        />
      </div>

      <div className={`mt-5 ${compact ? "" : "md:flex md:items-end md:justify-between md:gap-8"}`}>
        <div className="min-w-0">
          <h3
            data-testid="press-video-headline"
            className="font-display font-black uppercase tracking-tight leading-[0.98] text-xl md:text-2xl"
          >
            {item.headline}
          </h3>
          <p className="text-white/70 text-sm md:text-base leading-relaxed mt-3 max-w-2xl">
            {item.dek}
          </p>
          <p className="text-[11px] uppercase tracking-[0.2em] text-white/40 mt-3">
            {item.author} · {item.authorTitle} · {item.dateLabel}
          </p>
        </div>
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer noopener"
          data-testid="press-video-read-story"
          className="mt-5 md:mt-0 inline-flex items-center justify-center gap-2 bg-[#B32027] hover:bg-[#D42730] text-white px-6 py-4 text-[10px] font-bold uppercase tracking-[0.25em] transition-colors whitespace-nowrap shrink-0"
        >
          Read the full story on News 12 <ArrowUpRight size={12} weight="bold" />
        </a>
      </div>
    </div>
  );
};

export default PressVideoFeature;
